import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';

/**
 * customized form control
 * @param {ReactElement} children child components to render
 * @param {any} props properties to be passed to the select
 * @returns {ReactElement} form control to wrap custom inputs
 */
const CustomFormControl = ({ children, ...props }) => {
	return (
		<FormControl
			variant='outlined'
			sx={{ width: '100%', mb: '2rem' }}
			{...props}
		>
			{children}
		</FormControl>
	);
};

CustomFormControl.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element),
	]).isRequired,
};

export default CustomFormControl;
